import styled from '@emotion/styled';
import { PillBadge } from '@lightspeed/flame/Badge';
import { themeGet } from '@lightspeed/flame/Core';

interface CustomProps {
  backgroundColor: string;
  borderColor: string;
}

export const StyledPillBadge = styled(PillBadge)<CustomProps>`
  letter-spacing: initial;
  font-size: ${themeGet('fontSizes.text-s')};
  text-transform: none;
  background-color: ${({ backgroundColor }) => themeGet(`colors.${backgroundColor}`)};
  border: solid 1px;
  border-color: ${({ borderColor }) => themeGet(`colors.${borderColor}`)};
  white-space: nowrap;
`;
